import BreedingManager from '../../build/contracts/BreedingManager.sol/BreedingManager.json';
import NetworkService from './network';
import wallet from './wallet';

const BreedingManagerContractABI = {
  async getContractBreedingManagerInstance() {
    try {
      if (window.BreedingManagerInstance) {
        return window.BreedingManagerInstance;
      } else {
        const networkId = await window.web3.eth.net.getId();
        const contractAddress = NetworkService.getContractBreedingManagerAddress(networkId);
        if (!contractAddress) {
          throw new Error(`Contract not found - Check that you are in the correct network, network detected: ${NetworkService.networks[networkId]}`);
        }
        const BreedingManagerInstance = new window.web3.eth.Contract(
          BreedingManager.abi,
          contractAddress
        );
        window.BreedingManagerInstance = BreedingManagerInstance
        return window.BreedingManagerInstance;
      }
    } catch(e) {
      console.log('Error getting contract instance!');
      throw e;
    }
  },

  async breed(nftMale, nftFemale, signature) {
    console.log({nftMale, nftFemale, signature})
    const BreedingManagerInstance = await this.getContractBreedingManagerInstance();
    return BreedingManagerInstance.methods.breed(nftMale, nftFemale, signature).send({ 
      from: wallet.address,
    }); 
  },

  async getBreedingState() {
    const BreedingManagerInstance = await this.getContractBreedingManagerInstance();
    return BreedingManagerInstance.methods.BREEDING_ACTIVE().call();
  },

  async flipBreedingState() {
    const BreedingManagerInstance = await this.getContractBreedingManagerInstance();
    return BreedingManagerInstance.methods.flipBreedingActive().send({
      from: wallet.address,
    });
  },

  async getBreedingPrice() {
    const BreedingManagerInstance = await this.getContractBreedingManagerInstance();
    return BreedingManagerInstance.methods.BREED_PRICE().call();
  },
  
  async setBreedingPrice(breedingPrice) {
    // console.log('breedingPrice', breedingPrice);
    const CollectableInstance = await this.getContractBreedingManagerInstance();
    return CollectableInstance.methods.setBreedPrice(breedingPrice).send({
      from: wallet.address,
    });
  },

}
export default BreedingManagerContractABI;